<template lang="pug">

table.ui.padded.fixed.table
    thead
        tr
            th.five.wide Name
            th.three.wide(v-if='$auth.isZmuekish') Unternehmen
            th.two.wide Start
            th.two.wide Ende
            th.three.wide Budget
    tbody
        tr(
            is="table-row"
            v-for="campaign in campaignModels"
            v-bind:key="campaign.id"
            v-bind:campaign-model="campaign"
            v-bind:company-models="companyModels"
        )

</template>

<script>
    import TableRow from './TableRow'

    export default {

        components: { TableRow },

        props: {

            campaignModels: {
                type: Array,
                required: true
            },

            companyModels: {
                type: Array,
                required: true
            },

        }

    }

</script>
